import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../../context/LanguageContext";

const CoreFeatures = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("CoreFeatures", "home/home_CoreFeatures_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.CoreFeatures || { Main: {} };

  return (
    <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
      <div className="container py-5">
        <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{ maxWidth: "600px" }}>
          <h5 className="fw-bold text-primary text-uppercase">{LANGUAGE.Main.Content1}</h5>
          <h1 className="mb-0">{LANGUAGE.Main.Content2}</h1>
        </div>
        <div className="row g-5">
          {/* Left 3 Features */}
          <div className="col-lg-4">
            <div className="row g-5">
              <div className="col-12 wow zoomIn" data-wow-delay="0.2s">
                <div className="bg-primary rounded d-flex align-items-center justify-content-center mb-3" style={{ width: "60px", height: "60px" }}>
                  <i className="fa fa-robot text-white"></i>
                </div>
                <h4>{LANGUAGE.Main.Content3}</h4>
                <p className="mb-0">{LANGUAGE.Main.Content4}</p>
              </div>
              <div className="col-12 wow zoomIn" data-wow-delay="0.6s">
                <div className="bg-primary rounded d-flex align-items-center justify-content-center mb-3" style={{ width: "60px", height: "60px" }}>
                  <i className="fa fa-chart-line text-white"></i>
                </div>
                <h4>{LANGUAGE.Main.Content5}</h4>
                <p className="mb-0">{LANGUAGE.Main.Content6}</p>
              </div>
              <div className="col-12 wow zoomIn" data-wow-delay="0.6s">
                <div className="bg-primary rounded d-flex align-items-center justify-content-center mb-3" style={{ width: "60px", height: "60px" }}>
                  <i className="fa fa-rocket text-white"></i>
                </div>
                <h4>{LANGUAGE.Main.Content7}</h4>
                <p className="mb-0">{LANGUAGE.Main.Content8}</p>
              </div>
            </div>
          </div>

          {/* Middle Image */}
          <div className="col-lg-4 wow zoomIn" data-wow-delay="0.9s" style={{ minHeight: "350px" }}>
            <div className="position-relative h-100">
              <img className="position-absolute w-100 h-100 rounded wow zoomIn"
                data-wow-delay="0.1s"
                src="../../../img/feature_2.png"
                style={{ objectFit: "cover" }}
                alt="MAS Feature" />
            </div>
          </div>

          {/* Right 3 Features */}
          <div className="col-lg-4">
            <div className="row g-5">
              <div className="col-12 wow zoomIn" data-wow-delay="0.4s">
                <div className="bg-primary rounded d-flex align-items-center justify-content-center mb-3" style={{ width: "60px", height: "60px" }}>
                  <i className="fa fa-random text-white"></i>
                </div>
                <h4>{LANGUAGE.Main.Content9}</h4>
                <p className="mb-0">{LANGUAGE.Main.Content10}</p>
              </div>
              <div className="col-12 wow zoomIn" data-wow-delay="0.8s">
                <div className="bg-primary rounded d-flex align-items-center justify-content-center mb-3" style={{ width: "60px", height: "60px" }}>
                  <i className="fa fa-toggle-on text-white"></i>
                </div>
                <h4>{LANGUAGE.Main.Content11}</h4>
                <p className="mb-0">{LANGUAGE.Main.Content12}</p>
              </div>
              <div className="col-12 wow zoomIn" data-wow-delay="0.8s">
                <div className="bg-primary rounded d-flex align-items-center justify-content-center mb-3" style={{ width: "60px", height: "60px" }}>
                  <i className="fa fa-book text-white"></i>
                </div>
                <h4>{LANGUAGE.Main.Content13}</h4>
                <p className="mb-0">{LANGUAGE.Main.Content14}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoreFeatures;
